import React from 'react';
import PropTypes from 'prop-types';
import { ResultWrapper, FirstEntryResult, SecondEntryResult, TieBreakSup } from './styles';
import * as matchStatus from '../../../constants';
import Label from '../../shared/Label';

const TennisResult = ({
  firstEntry, secondEntry, status, isMobile,
}) => {
  const isLive = () => status === matchStatus.INPLAY;
  return (
    <ResultWrapper>
      <FirstEntryResult>
        {firstEntry.get('sets').map((set, k) => (
          k === (firstEntry.get('sets').size - 1) ?
            <React.Fragment key={k}>
              <Label
                label={set.get('points')}
                weight={isLive() || set.get('winner') ? 'bold' : ''}
                color={isLive() ? 'liveColor' : ''}
                size={isMobile ? 0.7 : 0.8}
                margin="0 7px 0px 0"
              />
              {set.get('tieBreakPoints') !== 0 && set.get('tieBreakPoints') !== '' &&
                <TieBreakSup
                  weight={isLive() || set.get('winner') ? 'bold' : ''}
                  color={isLive() ? 'liveColor' : ''}
                >
                  {set.get('tieBreakPoints')}
                </TieBreakSup>
              }
            </React.Fragment>
            :
            <React.Fragment key={k}>
              <Label
                label={set.get('points')}
                weight={set.get('winner') ? 'bold' : ''}
                size={isMobile ? 0.7 : 0.8}
                margin="0 7px 0 0"
              />
              {set.get('tieBreakPoints') !== 0 && set.get('tieBreakPoints') !== '' &&
                <TieBreakSup>{set.get('tieBreakPoints')}</TieBreakSup>
              }
            </React.Fragment>
        ))}
      </FirstEntryResult>
      <SecondEntryResult>
        {secondEntry.get('sets').map((set, k) => (
          k === (secondEntry.get('sets').size - 1) ?
            <React.Fragment key={k}>
              <Label
                label={set.get('points')}
                weight={isLive() || set.get('winner') ? 'bold' : ''}
                color={isLive() ? 'liveColor' : ''}
                size={isMobile ? 0.7 : 0.8}
                margin="0 7px 0 0"
              />
              {set.get('tieBreakPoints') !== 0 && set.get('tieBreakPoints') !== '' &&
                <TieBreakSup
                  weight={isLive() || set.get('winner') ? 'bold' : ''}
                  color={isLive() ? 'liveColor' : ''}
                >
                  {set.get('tieBreakPoints')}
                </TieBreakSup>
              }
            </React.Fragment>
            :
            <React.Fragment key={k}>
              <Label
                label={set.get('points')}
                weight={set.get('winner') ? 'bold' : ''}
                size={isMobile ? 0.7 : 0.8}
                margin="0 7px 0 0"
              />
              {set.get('tieBreakPoints') !== 0 && set.get('tieBreakPoints') !== '' &&
                <TieBreakSup>{set.get('tieBreakPoints')}</TieBreakSup>
              }
            </React.Fragment>
        ))}
      </SecondEntryResult>
    </ResultWrapper>
  );
};

TennisResult.propTypes = {
  firstEntry: PropTypes.any,
  secondEntry: PropTypes.any,
  status: PropTypes.any,
  isMobile: PropTypes.bool,
};

export default TennisResult;
